<template>
    <div class="wlx-tea-basic-info-main">
        <div class="revise-phone-number clearfix">
            <h3 class="h3-wl-title"><span class="sp-border-class"></span> <span class="sp-title-text">新的手机号</span></h3>
            <el-input v-model="input" placeholder="请输入手机号"></el-input>
            <h3 class="h3-wl-title"><span class="sp-border-class"></span> <span class="sp-title-text">验证码</span></h3>
            <div class="captcha-phone-input">
                <el-input v-model="captcha" placeholder="请输入验证码"></el-input>
            </div>
            <el-button v-if="show1" type="primary" class="captcha-phone-button" @click="sendMessage()">发送验证码</el-button>
            <el-button v-if="show2" type="primary" :disabled="true" class="captcha-phone-button">{{count}}s</el-button>
            <el-button v-if="show3" type="primary" class="captcha-phone-button" @click="sendMessage()">重新获取验证码</el-button>
        </div>
        <div class="confirm-revise-button">
          <el-button type="primary" class="confirm-primary-button" @click="updatePhone">确认修改</el-button>
        </div>
    </div>
</template>

<script>
import CryptoJS from "crypto-js";
export default {
    data() {
        return{
            input: '',
            captcha:'',
            count: 0,
            show1: true,
            show2: false,
            show3: false,
        }
    },
    methods:{
    //验证码
    sendMessage() {
      debugger;
      var once = true;
      let str_ = Date.parse(new Date()) / 1000;
      let str = this.encryption(str_);
      let str1 = CryptoJS.MD5(str_ + "").toString();
      var s1 = str1.substring(0, 7);
      var s2 = str1.substring(7);
      str1 = s1 + "s" + s2;
      debugger;
      if (once) {
        var that = this;
        this.$http.post("/api/XOrg/XLogin/sendCode",{
          verifyInfo: this.input,
          str: str,
          str1: str1
        }).then(rst => {
          if (rst.code > 0) {
            this.$message.success(rst.msg);
            this.verifyCode = rst.verifyCode;
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show1 = false;
              this.show2 = true;
              this.show3 = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                  once = false;
                } else {
                  this.show1 = false;
                  this.show2 = false;
                  this.show3 = true;
                  clearInterval(this.timer);
                  this.timer = null;
                  once = true;
                }
              }, 1000);
            }
          } else {
            this.$message.warning(rst.msg);
          }
        });
      }
    },
    encryption: function(str) {
      let Base64 = require("js-base64").Base64;
      return Base64.encode(str);
    },
    updatePhone() {
      debugger;
      let self = this;
      this.$http.post("/api/XOrg/AOrgInfo/updatePhone",
        {
          moblie: self.input,
          captcha: self.captcha,
        }).then(function(res) {
          if (res.code == 1) {
            self.$message.success(res.msg);
          } else {
            self.$message.warning(res.msg);
          }
        });
    }
    }
}
</script>

<style lang="scss">
.wlx-tea-basic-info-main{
     .revise-phone-number{
        width: 400px;
    }
    .h3-wl-title {
        margin-top: 30px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        padding-bottom: 16px;
        .sp-title-text {
            vertical-align: 2px;
        }
        .sp-border-class {
            display: inline-block;
            width: 3px;
            height: 14px;
            background: #2D82FF;
            margin-right: 11px;
        }
    }
    .captcha-phone-input{
      float: left;
      width: 266px;
  }
  .captcha-phone-button{
        float: right;
        background: #2D82FF;
        border-color: #2D82FF;
        font-size: 12px;
        padding: 12px 12px;
        width: 110px;
        border-radius: 4px;
    }
    .confirm-primary-button{
        margin-top: 24px;
        background: #2D82FF;
        border-color: #2D82FF;
        font-size: 12px;
        padding: 12px 12px;
        width: 110px;
        border-radius: 4px;
    }
}
</style>


